import React, { useContext, useEffect, useState } from "react";
import { downloadFormatoTebcaAPI, guardarFormatoTebcaFirmadaAPI, subirFirmaDocumentosIngresoAPI } from "../../../consumers/backendApisUrls";
import { AuthContext } from "../../../hooks/context/authContext";
import { usePostRequest } from "../../../hooks/usePostRequest/usePostRequest";
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../../consumers/httpRequiestsUtils";
import { toast } from "react-toastify";
import { FILE_FORMATS, GENERIC_SUCCESS_TOAST_MESSAGE } from "../../../constants/hardCodedConstants";
import { downloadFile } from "../../../consumers/backendConsumer";
import GenericModal from "../../../components/modal/GenericModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputUploadFile from "../../../components/modalComponents/InputUploadFile";

const FirmaFormatoTebca = ({ showModal, idEmpleado, idEmpleadoFlujoActividad, manageSearch }) => {
    const KEYS_INIT = { FirmaFileViewModel: "FirmaFileViewModel" };
    const SECTION_NAME = "FirmarFormatoTebca";
    const { state } = useContext(AuthContext);
    const [executePostRequest] = usePostRequest();
    const [validation, setValidation] = useState({});
    const [subiendoArchivo, setSubiendoArchivo] = useState(false);
    const [firmaColaborador, setFirmaColaborador] = useState({});
    const [documentoFirmado, setDocumentoFirmado] = useState({});
    const [guardando, setGuardando] = useState(false);
    const sectionName = "modalFirmaFormatoTebcaModal";

    const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    const init = async function () {

    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (guardando) return;
        if (!validaciones()) return;
        const docFirmado = await validarDocumentoFirmado();

        if (!docFirmado) {
            mostrarMensajeDeErrorConToast("No se pudo generar el documento firmado. Intente nuevamente.");
            return;
        }
        let payload = {
            IdEmpleado: idEmpleado,
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: docFirmado
        };
        setGuardando(true);
        const response = await executePostRequest(guardarFormatoTebcaFirmadaAPI(), payload);
        if (responseCode200(response)) {
            showModal();
            toast.success((response?.data?.Message) ? response?.data?.Message : GENERIC_SUCCESS_TOAST_MESSAGE);
            setGuardando(false);
            await manageSearch();
        } else if (responseTieneModelState(response)) {
            setValidation(response?.response?.data.ModelState);
            setGuardando(false);
        } else {
            mostrarMensajeDeErrorConToast(response);
            setGuardando(false);
        }
    };

    const validaciones = () => {
        // 1. Validar que al menos haya subido la firma (el origen)
        if (isEmptyObject(firmaColaborador) || !firmaColaborador.OriginalFileName) {
            mostrarMensajeDeErrorConToast("Debe subir su firma antes de guardar.");
            return false;
        }

        return true;
    }
    const validarDocumentoFirmado = async () => {
        if (isEmptyObject(documentoFirmado)) {
            const dataBody = await obtenerFormatoFirmado();
            return dataBody;
        }
        else
            return documentoFirmado;
    }
    const btnDownloadFormatoTebca = async (event) => {
        event.preventDefault();
        const dataBody = await obtenerFormatoFirmado();
        if (dataBody)
            downloadFile(state.token, dataBody?.Path, dataBody?.OriginalFileName);

    };

    const obtenerFormatoFirmado = async () => {
        const updatedFirmaColaborador = {
            IdEmpleadoFlujoActividad: idEmpleadoFlujoActividad,
            FileViewModel: firmaColaborador
        };
        const response = await executePostRequest(downloadFormatoTebcaAPI(), updatedFirmaColaborador);
        if (responseCode200(response)) {
            setDocumentoFirmado(response.data.Body);
            return response.data.Body;
        } else {
            mostrarMensajeDeErrorConToast(response);
            setDocumentoFirmado({});
            return null;
        }
    }
    return (
        <>
            <GenericModal showModal={showModal} width={"890px"} titulo="Firmar Formato Tebca">
                <div className="margin-modal-body">
                    <div>
                        <form className="black-color-important">
                            <div className="row custom-form-group-modal">
                                <div>
                                    <InputUploadFile
                                        label="Firmar"
                                        direction="column"
                                        textButton="Subir Firma"
                                        name={KEYS_INIT.FirmaFileViewModel}
                                        uploadFile={firmaColaborador}
                                        setUploadFile={setFirmaColaborador}
                                        isUploading={subiendoArchivo}
                                        setIsUploading={setSubiendoArchivo}
                                        sectionName={SECTION_NAME}
                                        showToastSuccess={true}
                                        validExtensions={FILE_FORMATS.ALLOWED_IMAGE_FORMATS} />
                                </div>
                            </div>

                            <div className="row custom-form-group-modal">
                                <u>
                                    <a className="text-link-appereance" href="#" onClick={(event) => btnDownloadFormatoTebca(event)}><FontAwesomeIcon icon='download' /> Previsualizar Formato Tebca</a>
                                </u>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="modal-footer" style={{ 'display': 'flex', 'justifyContent': 'space-between' }}>
                    <div className="message font-gothan-light" style={{ 'alignSelf': 'flex-start' }}>
                        <strong>
                            <p>* Campos obligatorios</p>
                            <p>* El formato permitido es un archivo .jpg o .png.</p>
                            <p>* Esta firma servirá para generar tu formato de autorizacion TEBCA y se eliminará automáticamente después de aprobarse la solicitud.</p>
                            <p>* Luego de subir su firma previsualizar el documento para poder guardar.</p>
                        </strong>
                    </div>
                    <div className="button" style={{ 'alignSelf': 'flex-end' }}>
                        <button className="btn btn-primary generic-button-ficha" onClick={onSubmit} disabled={subiendoArchivo || guardando}>Guardar</button>
                    </div>
                </div>
            </GenericModal>
        </>
    );
}
export default FirmaFormatoTebca;